import {PriceModel} from '../Price.model';
import {PriceSummary} from '@wix/auto_sdk_ecom_current-cart';
import {ModelContext} from '../../../types/app.types';

export class PriceSummaryModel {
  public subtotal: PriceModel;
  public shipping: PriceModel;
  public tax: PriceModel;
  /**
   * @deprecated
   */
  public discount: PriceModel;
  public total: PriceModel;
  public additionalFees: PriceModel;

  constructor(params: PriceSummaryModel) {
    this.subtotal = params.subtotal;
    this.shipping = params.shipping;
    this.tax = params.tax;
    this.discount = params.discount;
    this.total = params.total;
    this.additionalFees = params.additionalFees;
  }

  public static fromCartV1(priceSummary: PriceSummary, modelContext: ModelContext) {
    return new PriceSummaryModel({
      subtotal: PriceModel.fromCartV1(priceSummary.subtotal, modelContext),
      total: PriceModel.fromCartV1(priceSummary.total, modelContext),
      tax: PriceModel.fromCartV1(priceSummary.tax, modelContext),
      discount: PriceModel.fromCartV1(priceSummary.discount, modelContext),
      additionalFees: PriceModel.fromCartV1(priceSummary.additionalFees, modelContext),
      shipping: PriceModel.fromCartV1(priceSummary.shipping, modelContext),
    });
  }
}
